import { NaverMonthRow, CoupangMonthRow, EasyCheckMonthRow, HometaxMonthRow, TumblbugMonthRow } from './types';

export type NaverKey = '제주' | '남해' | '해피빈';

export interface VatDraft {
  naver: Record<NaverKey, NaverMonthRow[]>;
  coupang: CoupangMonthRow[];
  easyCheck: EasyCheckMonthRow[];
  hometax: HometaxMonthRow[];
  tumblbug: TumblbugMonthRow[];
}

export function emptyDraft(): VatDraft {
  return { naver: { 제주: [], 남해: [], 해피빈: [] }, coupang: [], easyCheck: [], hometax: [], tumblbug: [] };
}

const keyFor = (year: number, half: string) => `vat-draft-${year}-${half}`;

export function loadDraft(year: number, half: string): VatDraft {
  const base = emptyDraft();
  try {
    const raw = localStorage.getItem(keyFor(year, half));
    if (!raw) return base;
    const p = JSON.parse(raw);
    return {
      naver: {
        제주: p?.naver?.제주 ?? base.naver.제주,
        남해: p?.naver?.남해 ?? base.naver.남해,
        해피빈: p?.naver?.해피빈 ?? base.naver.해피빈,
      },
      coupang: p?.coupang ?? base.coupang,
      easyCheck: p?.easyCheck ?? base.easyCheck,
      hometax: p?.hometax ?? base.hometax,
      tumblbug: p?.tumblbug ?? base.tumblbug,
    };
  } catch {
    return base;
  }
}

export function saveDraft(year: number, half: string, draft: VatDraft): void {
  try { localStorage.setItem(keyFor(year, half), JSON.stringify(draft)); } catch { /* quota/unavailable 무시 */ }
}

export function clearDraft(year: number, half: string): void {
  try { localStorage.removeItem(keyFor(year, half)); } catch { /* 무시 */ }
}
